import jQuery from 'jquery';

function Directive($compile, $window) {
  return {
    restrict: 'A',
    link(scope, element, attrs) {
      scope.btnSelect = attrs.btnSelect;
      scope.btnSelectModel = attrs.btnSelectModel;
      scope.btnSelectItemProp = attrs.btnSelectItemProp;
      scope.btnSelectItemValue = attrs.btnSelectItemValue;

      const ngOptionsExpression = `a.${scope.btnSelectItemProp} as a.${scope.btnSelectItemValue} for a in ${scope.btnSelect}`;

      const wrapper = jQuery('<div></div>').css('position', 'relative').addClass('btn-select');

      const template = jQuery('<select></select>');
      template.attr('ng-options', ngOptionsExpression);
      template.attr('ng-model', scope.btnSelectModel);

      const compiledTemplate = $compile(template)(scope);

      element.wrap(wrapper);
      element.after(compiledTemplate);

      element.on('click', () => {
        open(template);
      });

      compiledTemplate
        .css('opacity', 0)
        .css('position', 'absolute')
        .css('bottom', 0)
        .css('left', '50%')
        .css('width', '0');

      function open(elem) {
        if (document.createEvent) {
          const e = document.createEvent('MouseEvents');
          e.initMouseEvent('mousedown', true, true, $window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          elem[0].dispatchEvent(e);
        } else if (element.fireEvent) {
          elem[0].fireEvent('onmousedown');
        }
      }
    }
  };
}

Directive.$inject = [
  '$compile',
  '$window'
];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/btnSelect/index.js